
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { DashboardType } from 'enums/DashboardType';
import { TeamDashboardElementModel } from './Identity.Api.Models.TeamDashboardElement';
import { Model, ModelProperty } from 'models/Model';


export class DashboardElementModel extends Model<DashboardElementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'description', type: 'string' },
		{ name: 'type', type: 'DashboardType' },
		{ name: 'configurationMetaData', type: 'string' },
		{ name: 'configuration', type: 'DashboardElementConfigurationModel', isHidden: true, isObject: true, new: () => { return new DashboardElementConfigurationModel }, properties: () => { return DashboardElementConfigurationModel.classProperties } },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'teamDashboardElements', type: 'TeamDashboardElementModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TeamDashboardElementModel }, properties: () => { return TeamDashboardElementModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public description?: string;
	public type: DashboardType;
	public configurationMetaData: string;
	public configuration?: DashboardElementConfigurationModel;
	public deleted?: Date;
	public teamDashboardElements: TeamDashboardElementModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.description = undefined;
		this.type = 0;
		this.configurationMetaData = '';
		this.configuration = undefined;
		this.deleted = undefined;
		this.teamDashboardElements = [];
		
	}
	getProperties(){
		return DashboardElementModel.classProperties;
	}
}
export class DashboardElementConfigurationModel extends Model<DashboardElementConfigurationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'header', type: 'string' },
		{ name: 'content', type: 'string' }
	];
	[key: string]: any;
	
	public header: string;
	public content: string;
    
	constructor(){
		super();
		this.header = '';
		this.content = '';
		
	}
	getProperties(){
		return DashboardElementConfigurationModel.classProperties;
	}
}

